import React from 'react';
import KickImage from 'Reuseables/KickImage';

import { ISearchBarProps } from './SearchBar.definitions';

/** CSS import */
import Styles from './SearchBar.module.scss';

import SearchImg from 'images/search-black.png';
import ClearImg from 'images/cancel-x.png';
import { useHistory } from 'react-router';
import { LooseObject } from 'helpers/type';

const SearchBar: React.FC<ISearchBarProps> = ({
  onSearch,
  setIsTyping,
  onCancel,
  searchValue,
  onClose,
  isOpened,
}: ISearchBarProps) => {
  const [text, setText] = React.useState('');
  const inputRef = React.useRef<HTMLInputElement>(null);

  const history = useHistory();

  React.useEffect(() => {
    if (isOpened) {
      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.focus();
        }
      }, 1000);
    }
  }, [isOpened]);

  const onSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setText(e.target.value);
    onSearch(e.target.value);
    if (e.target.value.length > 0) {
      setIsTyping(true);
      return;
    }
    setIsTyping(false);
  };

  const handleKeyDown = (event: LooseObject) => {
    if (event.key === 'Enter') {
      // 👇 Get input value
      if (inputRef.current) {
        inputRef.current.blur();
      }
      history.push(`/kickavenews/search/${text}`);
      onClose();
    }
  };

  const onClear = () => {
    onSearch('');
    if (inputRef.current) {
      inputRef.current.value = '';
    }
    setIsTyping(false);
  };

  React.useEffect(() => {
    setText(searchValue);
  }, [searchValue]);

  return (
    <div className={Styles['wrapper']}>
      <KickImage src={SearchImg} alt="Search" className={Styles['search-icon']} />
      <input
        type="text"
        placeholder="Search Article"
        className={Styles['search-input']}
        onChange={onSearchChange}
        value={searchValue}
        onKeyDown={handleKeyDown}
        ref={inputRef}
      />
      {searchValue.length !== 0 && (
        <div className={Styles['search-clear-button']} onClick={onClear}>
          <KickImage
            src={ClearImg}
            alt="Clear"
            className={Styles['search-clear-icon']}
          />
        </div>
      )}
      <div className={Styles['search-cancel-button']} onClick={onCancel}>
        <span className={Styles['search-cancel-button-text']}>Cancel</span>
      </div>
    </div>
  );
};

export default SearchBar;
